<template>
  <div id="finances">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Finances</div>
        </section-heading>
      </div>
    </div>
    <div class="row" v-if="report.companyoverview.financials.length > 0">
      <div class="col-md-12">
        <financial-reporting :report="report" :show-diff="showDiff" />
        <key-financials :report="report" :show-diff="showDiff" />
        <profit-loss :report="report" :show-diff="showDiff" />
        <balance-sheet :report="report" :show-diff="showDiff" />
        <key-ratios :report="report" :show-diff="showDiff" />
      </div>
    </div>
    <div class="row" v-else>
      <div class="well well-sm well-neutral">
        <table class="table-condensed">
          <tbody>
            <tr>
              <td width="50" style="text-align: center">
                <i class="fas fa-exclamation-circle"></i>
              </td>
              <td>
                <h4>Financial information not available for this company</h4>
                <p>
                  We are unable to find any accounts information for this company, this could be for
                  a number of reasons including that the business was only recently incorporated and
                  has not yet submitted accounts.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="sectionBreak row"></div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import FinancialReporting from '@/components/reports/panels/financials/FinancialReporting';
import KeyFinancials from '@/components/reports/panels/financials/KeyFinancials';
import ProfitLoss from '@/components/reports/panels/financials/ProfitLoss';
import BalanceSheet from '@/components/reports/panels/financials/BalanceSheet';
import KeyRatios from '@/components/reports/panels/financials/KeyRatios';

export default {
  components: {
    SectionHeading,
    FinancialReporting,
    KeyFinancials,
    ProfitLoss,
    BalanceSheet,
    KeyRatios,
  },
  computed: {
    hasNetAssetDiff() {
      const result = this.diffData.find((d) => d.type === 'net_assets');
      return result !== undefined;
    },
    hasPostTaxProfitDiff() {
      const result = this.diffData.find((d) => d.type === 'post_tax_profit');
      return result !== undefined;
    },
    hasTurnoverDiff() {
      const result = this.diffData.find((d) => d.type === 'turnover');
      return result !== undefined;
    },
  },
  props: ['report', 'showDiff', 'diffData'],
};
</script>
